import IComponent from "components/commons/IComponent";
import "./DetailPanels.scoped.css";

import { cacheItemResult } from "store/searchResultSlice";

import PhotoFrame from "components/commons/PhotoFrame";

class Photo extends IComponent {
  constructor(props) {
    super(props);
    console.log("photo props", props);
    this.state = {
      urlList: [],
    };
  }
  componentWillUnmount() {}
  async componentDidMount() {
    console.log("photo did mount");

    if (this.props.text !== "") {
      let finalPhotoResult = this.props.attributes.Photos;
      console.log("finalPhotoResult", finalPhotoResult);
      if (finalPhotoResult && finalPhotoResult.length > 0) {
        this.setState({ urlList: finalPhotoResult });
        this.props.reduxCallProxy(cacheItemResult, {
          panelKey: "photo",
          data: { urlList: finalPhotoResult },
        });
      }
      this.props.isShowTabCallback(
        finalPhotoResult && finalPhotoResult.length > 0
      );
    }
  }
  render() {
    return <PhotoFrame urlList={this.state.urlList.map((i) => i.URL)} />;
  }
}
export default Photo;
